export default __webpack_public_path__ + "tos/TOS_9_11_2023.html";